import { encryptStorage } from 'src/Util'
import { profileAPI } from "../api";

export const PROFILE_DETAILS_SUCCESS = 'PROFILE_DETAILS_SUCCESS'
export const PROFILE_DETAILS_FAILURE = 'PROFILE_DETAILS_FAILURE'

export const EDIT_NAME = 'EDIT_NAME'
export const EDIT_NAME_SUCCESS = 'EDIT_NAME_SUCCESS'

export const EDIT_TITLE = 'EDIT_TITLE'
export const EDIT_TITLE_SUCCESS = 'EDIT_TITLE_SUCCESS'

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'

export const OUT_OF_OFFICE = 'OUT_OF_OFFICE'
export const OUT_OF_OFFICE_SUCCESS = 'OUT_OF_OFFICE_SUCCESS'

export const UPLOAD_PROFILE_PIC = 'UPLOAD_PROFILE_PIC'
export const UPLOAD_PROFILE_PIC_SUCCESS = 'UPLOAD_PROFILE_PIC_SUCCESS'

export const DISPLAY_NOTIFICATION = 'DISPLAY_NOTIFICATION'
export const DISPLAY_NOTIFICATION_SUCCESS = 'DISPLAY_NOTIFICATION_SUCCESS'

export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'

export const getProfileDetailsSuccess = (details) => (
    {
        type:PROFILE_DETAILS_SUCCESS,
        payload: details
    }
)

export const getProfileDetailsFailure = (errorMessage) => ({
    type: PROFILE_DETAILS_FAILURE,
    payload: errorMessage
})

export const getAccountDetails = () => (dispatch) => {

    const userDetail = (encryptStorage.getItem('session-user'))

    // const data = {
    //     current_user_id : `${userDetail.user_id}`
    //     company_id : `${userDetail.company_id}`,
    // }
    
    profileAPI.get(`/user/${userDetail.user_id}`)
        .then((res)=>{
            if(res.data.status === 'success') encryptStorage.setItem('session-auth', true)
            dispatch(getProfileDetailsSuccess(res.data));
            if(res.data.role_name.length > 0) encryptStorage.setItem('session-role', res.data.role_name);
        })
        .catch((error)=>{
            dispatch(getProfileDetailsFailure(error))
        })
}

export const editUserName = (editDetail) => (dispatch) => {
    profileAPI.post(`/user/updateUserName`, editDetail,
    {
        headers:{'Content-Type':'application/json'}
    }).then((res)=>{
        console.log("edit user details:", res.data)
        dispatch({
            type:EDIT_NAME,
            payload:res.data
        })
    })
}

export const editUserTitle = (editDetail) => (dispatch) => {
    profileAPI.post(`/user/updateTitle`, editDetail,
    {
        headers:{'Content-Type':'application/json'}
    }).then((res)=>{
        console.log("edit user details:", res.data)
        dispatch({
            type:EDIT_TITLE,
            payload:res.data
        })
    })
}

export const changeUserPassword = (editDetail) => (dispatch) => {
    profileAPI.post(`/user/updatepasswordaccount/`, editDetail,
    {
        headers:{'Content-Type':'application/json'}
    }).then((res)=>{
        dispatch({
            type:UPDATE_PASSWORD,
            payload:res.data
        })
    })
}

export const getOutOfOffice = (outDetail) => (dispatch) => {
    profileAPI.post(`/user/addoutofoffice/`, outDetail, 
    {
        headers:{'Content-Type':'application/json'}
    }).then((res)=>{
        dispatch({
            type:OUT_OF_OFFICE,
            payload:res.data
        })
    })
}

export const uploadProfilePic = (picDetail) => (dispatch) => {
    profileAPI.post(`/user/updateprofilepic/`, picDetail, 
    {
        headers:{'Content-Type':'application/json'}
    }).then((res)=>{
        dispatch({
            type:UPLOAD_PROFILE_PIC,
            payload:res.data
        })
    })
}

export const displayAllCompanyNotification = ()=> (dispatch) => {
    const userDetail = (encryptStorage.getItem('session-user'))
    const data = {
        company_id: `${userDetail.company_id}`
    }
    profileAPI.post('/user/displayallnoticiationcompany/', data).then((res)=>{
        dispatch({
            type:DISPLAY_NOTIFICATION,
            payload:res.data,
        })
    })
    
}

export const updateCompanyNotication = (notificationDetail) => (dispatch)=>{
    profileAPI.post(`/user/updateCompanyNotification/`, notificationDetail, {
        headers:{'content-Type':'application/json'}
    }).then((res)=>{
        dispatch({
            type:UPDATE_NOTIFICATION,
            payload:res.data
        })
    })
}